module.exports = __webpack_public_path__ + "static/media/main.9fc224d3.png";